
import * as ipxRuntime$IORote2Juw from '/codebuild/output/src350537077/src/actions-runner/_work/onenews/onenews/web-services/node_modules/.pnpm/@nuxt+image@1.9.0_@azure+identity@4.10.2_@azure+storage-blob@12.27.0_ioredis@5.6.0_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$IORote2Juw, defaults: {} }
}
        